// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General Reset */
*,
*::before,
*::after {
    box-sizing: border-box;
}

html,
body {
    font-family: Arial, sans-serif;
    font-display: swap;
    scroll-behavior: smooth;
    margin: 0;
    padding: 0;
    user-select: none;
}

body {
    line-height: 1.6;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    overflow-x: hidden;
}

li,
h1,
h2,
h3,
p {
    user-select: text;
}

a:link,
a:visited {
    color: inherit;
    text-decoration: none;
}

/* Header */
header {
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgb(8, 13, 23);
    color: rgb(255, 255, 255);
    padding: 1rem 0;
}

header .container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 80%;
    max-width: 1500px;
    padding: 0 2rem;
}

.logo {
    width: 120px;
}
.logo a {
    display: inline-block;
}
.logo img {
    display: block;
    width: 100%;
    height: auto;
}

.menu-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    gap: 25px;
    font-size: 1.1rem;
}

.contact-top {
    align-items: center;
    width: 180px;
    padding-left: 20px;
    color: rgb(255, 255, 255);
    user-select: text;
}

.contact-top .phone-icon {
    width: 18px;
    margin-right: 0.5rem;
}

.phone-number {
    font-weight: bold;
}

.nav-links ul {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 1rem;
}

.nav-links li {
    margin: 0;
}

.nav-links a {
    position: relative;
    color: rgb(255, 255, 255);
    text-decoration: none;
    padding: 0.5rem 1rem;
}

.nav-links a::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 0;
    height: 2px; /* Thickness of the underline */
    background-color: rgb(157, 161, 164);
    transition: width 0.3s ease;
}

.nav-links a:hover::after {
    width: 100%; /* Expand underline on hover */
}

/* Contact button styling */
.secondary-cta {
    background: linear-gradient(rgb(220, 220, 220), rgb(170, 170, 170));
    color: rgb(8, 13, 23) !important;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    font-weight: bold;
    border: 2px solid #555;
    transition: all 0.3s ease;
}

.secondary-cta:hover {
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
    transform: scale(1.05);
}

/* Hamburger Button */
.hamburger {
    display: none;
    flex-direction: column;
    justify-content: space-between;
    width: 35px;
    height: 25px;
    background: none;
    border: none;
    cursor: pointer;
    /* margin-left: 5rem; */
}

.hamburger span {
    display: block;
    width: 100%;
    height: 4px;
    background: rgb(220, 220, 220) !important; /* Light gray */
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5); /* Subtle shadow */
    border: 1px solid rgba(0, 0, 0, 0.2); /* Optional border */
}

/* Responsive Nav */
@media (max-width: 1024px) {
    header .container {
        min-width: 100%;
    }
}

@media (max-width: 900px) {
    header .container {
        min-width: 90%;
        justify-content: center;
        padding: 0;
    }
    .logo {
        width: 80px;
    }
    .menu-wrapper {
        gap: 0;
        padding-bottom: 10px;
    }
    .contact-top {
        width: 120px;
        padding: 0 0 10px 0;
    }
    .contact-top .phone-icon {
        width: 13px;
    }
    .phone-number {
        font-size: 0.86rem;
    }

    .hamburger {
        display: flex; /* Show hamburger button on smaller screens */
    }
    .nav-links {
        display: none;
    }
    .nav-links.active {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 120px;
        right: 0;
        font-size: 1.1rem;
        background: rgb(8, 13, 23);
        width: 100%;
        z-index: 10;
        padding: 1rem;
    }
    .nav-links ul {
        flex-direction: column;
        gap: 1rem;
        align-items: center;
    }
}

@media (prefers-color-scheme: dark) {
    .hamburger span {
        background: rgb(255, 255, 255) !important; /* White for dark themes */
    }
}

/* Main */
main {
    flex: 1;
}

.primary-cta {
    display: inline-block;
    background: linear-gradient(172deg, rgb(255, 200, 0), rgb(238, 228, 141));
    color: rgb(8, 13, 23) !important;
    padding: 0.5rem 1rem;
    text-decoration: none;
    cursor: pointer;
    font-weight: bold;
    border: 3px outset rgb(8, 13, 23);
    border-radius: 5px;
    transition: all 0.3s ease;
}

.primary-cta:hover {
    box-shadow: 0 0 20px rgba(231, 181, 2, 1);
    transform: scale(1.05);
}

/* Footer */
footer {
    background: rgb(8, 13, 23);
    color: rgb(255, 255, 255);
    text-align: center;
    padding: 1rem;
}

.footer-content p {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0.5rem 0;
}

.social-icons {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 10px;
}

@media (max-width: 425px) {
    .break {
        display: block; /* Forces the break to act as a line break */
    }
}
`, "",{"version":3,"sources":["webpack://./src/shared.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;;;IAGI,sBAAsB;AAC1B;;AAEA;;IAEI,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAuB;IACvB,SAAS;IACT,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;;;;IAKI,iBAAiB;AACrB;;AAEA;;IAEI,cAAc;IACd,qBAAqB;AACzB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0BAA0B;IAC1B,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,qBAAqB;IACrB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,SAAS;IACT,UAAU;IACV,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,SAAS;IACT,QAAQ;IACR,WAAW,EAAE,+BAA+B;IAC5C,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,WAAW,EAAE,8BAA8B;AAC/C;;AAEA,2BAA2B;AAC3B;IACI,mEAAmE;IACnE,gCAAgC;IAChC,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;AAC1B;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;IACX,WAAW;IACX,yCAAyC,EAAE,eAAe;IAC1D,sCAAsC,EAAE,kBAAkB;IAC1D,oCAAoC,EAAE,oBAAoB;AAC9D;;AAEA,mBAAmB;AACnB;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,cAAc;QACd,uBAAuB;QACvB,UAAU;IACd;IACA;QACI,WAAW;IACf;IACA;QACI,MAAM;QACN,oBAAoB;IACxB;IACA;QACI,YAAY;QACZ,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa,EAAE,6CAA6C;IAChE;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;QAClB,UAAU;QACV,QAAQ;QACR,iBAAiB;QACjB,0BAA0B;QAC1B,WAAW;QACX,WAAW;QACX,aAAa;IACjB;IACA;QACI,sBAAsB;QACtB,SAAS;QACT,mBAAmB;IACvB;AACJ;;AAEA;IACI;QACI,yCAAyC,EAAE,0BAA0B;IACzE;AACJ;;AAEA,SAAS;AACT;IACI,OAAO;AACX;;AAEA;IACI,qBAAqB;IACrB,yEAAyE;IACzE,gCAAgC;IAChC,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,iCAAiC;IACjC,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yCAAyC;IACzC,sBAAsB;AAC1B;;AAEA,WAAW;AACX;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI;QACI,cAAc,EAAE,4CAA4C;IAChE;AACJ","sourcesContent":["/* General Reset */\n*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n\nhtml,\nbody {\n    font-family: Arial, sans-serif;\n    font-display: swap;\n    scroll-behavior: smooth;\n    margin: 0;\n    padding: 0;\n    user-select: none;\n}\n\nbody {\n    line-height: 1.6;\n    display: flex;\n    flex-direction: column;\n    min-height: 100vh;\n    overflow-x: hidden;\n}\n\nli,\nh1,\nh2,\nh3,\np {\n    user-select: text;\n}\n\na:link,\na:visited {\n    color: inherit;\n    text-decoration: none;\n}\n\n/* Header */\nheader {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgb(8, 13, 23);\n    color: rgb(255, 255, 255);\n    padding: 1rem 0;\n}\n\nheader .container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-width: 80%;\n    max-width: 1500px;\n    padding: 0 2rem;\n}\n\n.logo {\n    width: 120px;\n}\n.logo a {\n    display: inline-block;\n}\n.logo img {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n\n.menu-wrapper {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: flex-end;\n    gap: 25px;\n    font-size: 1.1rem;\n}\n\n.contact-top {\n    align-items: center;\n    width: 180px;\n    padding-left: 20px;\n    color: rgb(255, 255, 255);\n    user-select: text;\n}\n\n.contact-top .phone-icon {\n    width: 18px;\n    margin-right: 0.5rem;\n}\n\n.phone-number {\n    font-weight: bold;\n}\n\n.nav-links ul {\n    display: flex;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    gap: 1rem;\n}\n\n.nav-links li {\n    margin: 0;\n}\n\n.nav-links a {\n    position: relative;\n    color: rgb(255, 255, 255);\n    text-decoration: none;\n    padding: 0.5rem 1rem;\n}\n\n.nav-links a::after {\n    content: \"\";\n    position: absolute;\n    left: 0;\n    bottom: 0;\n    width: 0;\n    height: 2px; /* Thickness of the underline */\n    background-color: rgb(157, 161, 164);\n    transition: width 0.3s ease;\n}\n\n.nav-links a:hover::after {\n    width: 100%; /* Expand underline on hover */\n}\n\n/* Contact button styling */\n.secondary-cta {\n    background: linear-gradient(rgb(220, 220, 220), rgb(170, 170, 170));\n    color: rgb(8, 13, 23) !important;\n    padding: 0.5rem 1rem;\n    border-radius: 5px;\n    font-weight: bold;\n    border: 2px solid #555;\n    transition: all 0.3s ease;\n}\n\n.secondary-cta:hover {\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);\n    transform: scale(1.05);\n}\n\n/* Hamburger Button */\n.hamburger {\n    display: none;\n    flex-direction: column;\n    justify-content: space-between;\n    width: 35px;\n    height: 25px;\n    background: none;\n    border: none;\n    cursor: pointer;\n    /* margin-left: 5rem; */\n}\n\n.hamburger span {\n    display: block;\n    width: 100%;\n    height: 4px;\n    background: rgb(220, 220, 220) !important; /* Light gray */\n    box-shadow: 0 0 2px rgba(0, 0, 0, 0.5); /* Subtle shadow */\n    border: 1px solid rgba(0, 0, 0, 0.2); /* Optional border */\n}\n\n/* Responsive Nav */\n@media (max-width: 1024px) {\n    header .container {\n        min-width: 100%;\n    }\n}\n\n@media (max-width: 900px) {\n    header .container {\n        min-width: 90%;\n        justify-content: center;\n        padding: 0;\n    }\n    .logo {\n        width: 80px;\n    }\n    .menu-wrapper {\n        gap: 0;\n        padding-bottom: 10px;\n    }\n    .contact-top {\n        width: 120px;\n        padding: 0 0 10px 0;\n    }\n    .contact-top .phone-icon {\n        width: 13px;\n    }\n    .phone-number {\n        font-size: 0.86rem;\n    }\n\n    .hamburger {\n        display: flex; /* Show hamburger button on smaller screens */\n    }\n    .nav-links {\n        display: none;\n    }\n    .nav-links.active {\n        display: flex;\n        flex-direction: column;\n        position: absolute;\n        top: 120px;\n        right: 0;\n        font-size: 1.1rem;\n        background: rgb(8, 13, 23);\n        width: 100%;\n        z-index: 10;\n        padding: 1rem;\n    }\n    .nav-links ul {\n        flex-direction: column;\n        gap: 1rem;\n        align-items: center;\n    }\n}\n\n@media (prefers-color-scheme: dark) {\n    .hamburger span {\n        background: rgb(255, 255, 255) !important; /* White for dark themes */\n    }\n}\n\n/* Main */\nmain {\n    flex: 1;\n}\n\n.primary-cta {\n    display: inline-block;\n    background: linear-gradient(172deg, rgb(255, 200, 0), rgb(238, 228, 141));\n    color: rgb(8, 13, 23) !important;\n    padding: 0.5rem 1rem;\n    text-decoration: none;\n    cursor: pointer;\n    font-weight: bold;\n    border: 3px outset rgb(8, 13, 23);\n    border-radius: 5px;\n    transition: all 0.3s ease;\n}\n\n.primary-cta:hover {\n    box-shadow: 0 0 20px rgba(231, 181, 2, 1);\n    transform: scale(1.05);\n}\n\n/* Footer */\nfooter {\n    background: rgb(8, 13, 23);\n    color: rgb(255, 255, 255);\n    text-align: center;\n    padding: 1rem;\n}\n\n.footer-content p {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin: 0.5rem 0;\n}\n\n.social-icons {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 10px;\n    margin-top: 10px;\n}\n\n@media (max-width: 425px) {\n    .break {\n        display: block; /* Forces the break to act as a line break */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
